import { useState, useEffect, useCallback } from "react";

export function useNavExpanded(pathname) {
  // 현재 경로에 따라 적절한 메뉴를 자동으로 열기
  const getInitialExpandedKeys = useCallback(() => {
    const keys = {};
    // 현재 경로에 따라 해당 메뉴 열기
    if (pathname.startsWith('/yb/')) {
      keys.yb = true;
    } else if (pathname.startsWith('/eb/')) {
      keys.eb = true;
    } else if (pathname.startsWith('/dc/')) {
      keys.dc = true;
    } else if (pathname.startsWith('/common/golfinfo/event')) {
      keys.event = true;
    } else if (pathname.startsWith('/common/golfinfo') || pathname.startsWith('/common/golfacount') || pathname.startsWith('/analytics/timeline')) {
      keys.golfservice = true;
    } else if (pathname.startsWith('/home')) {
      keys.home = true;
    }
    return keys;
  }, [pathname]);
  
  const [expandedKeys, setExpandedKeys] = useState(() => getInitialExpandedKeys());

  // 경로가 변경될 때마다 적절한 메뉴 자동으로 열기
  useEffect(() => {
    const newExpandedKeys = getInitialExpandedKeys();
    setExpandedKeys(newExpandedKeys);
  }, [pathname, getInitialExpandedKeys]);

  const handleToggleExpand = (key) => {
    setExpandedKeys((prev) => {
      const currentState = prev[key] !== undefined ? prev[key] : false;
      
      // 아코디언 방식: 하나를 펼치면 다른 모든 항목은 닫힘
      if (!currentState) {
        // 현재 항목이 닫혀있으면, 모든 항목을 닫고 현재 항목만 열기
        return {
          [key]: true,
        };
      } else {
        // 현재 항목이 열려있으면, 현재 항목만 닫기
        return {
          ...prev,
          [key]: false,
        };
      }
    });
  };

  return { expandedKeys, handleToggleExpand };
}
